var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoble(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 600 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "cb-icon cb-icon-noble pointer-events-none",
    "aria-hidden": "true",
    "data-testid": "icon-noble",
    focusable: "false",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 600,
    rx: 300,
    fill: "#001"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_216_160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M410.899 145.007a43.133 43.133 0 0 0-43.02 43.083v22.656a117.566 117.566 0 0 0-144.631-59.053A117.51 117.51 0 0 0 145 262.36V410.9a43.097 43.097 0 0 0 43.101 43.1 43.099 43.099 0 0 0 43.1-43.1v-22.608a117.505 117.505 0 0 0 144.583 59.006A117.473 117.473 0 0 0 454 336.662V188.09a43.144 43.144 0 0 0-12.644-30.451 43.142 43.142 0 0 0-30.457-12.632Zm-74.255 297.064a104.884 104.884 0 0 1-100.729-74.19l-.176-.626a104.218 104.218 0 0 1-4.538-30.593V262.36a31.205 31.205 0 0 1 31.187-31.17 31.231 31.231 0 0 1 31.155 31.17v74.27a43.133 43.133 0 0 0 12.651 30.465 43.13 43.13 0 0 0 46.937 9.285 43.125 43.125 0 0 0 26.629-39.75V188.09a31.149 31.149 0 0 1 9.126-22.029 31.159 31.159 0 0 1 22.029-9.125 31.159 31.159 0 0 1 31.155 31.154v148.54a105.35 105.35 0 0 1-30.854 74.576 105.361 105.361 0 0 1-74.572 30.865Zm31.235-105.441a31.206 31.206 0 0 1-19.235 28.784 31.197 31.197 0 0 1-33.967-6.689c-3.2-3.169-5.668-7-7.232-11.224-.289-.753-.545-1.603-.802-2.453l-.096-.433-.096-.401c-.144-.561-.289-1.122-.385-1.715 0-.209 0-.433-.112-.658v-.336c0-.529-.16-1.059-.209-1.604-.048-.545 0-.657 0-1.09V262.36a43.18 43.18 0 0 0-12.737-30.549 43.184 43.184 0 0 0-30.62-12.566 43.162 43.162 0 0 0-43.116 43.115V410.9a31.17 31.17 0 0 1-62.342 0V262.36a105.457 105.457 0 0 1 206.363-30.577l.433 1.411a105.321 105.321 0 0 1 4.153 29.166v74.27Z",
    fill: "url(#paint0_linear_216_160)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_216_160",
    x1: 166.19,
    y1: 432.377,
    x2: 534.416,
    y2: 63.589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#A7B3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#74A4FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_216_160"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(145 145)",
    d: "M0 0h309v309H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoble);
export default __webpack_public_path__ + "static/media/NOBLE.c067f296605c07af7b4c5054ebc91e3b.svg";
export { ForwardRef as ReactComponent };